import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClausulaCobranzaComponent } from './clausula-cobranza.component';



@NgModule({
  declarations: [
    ClausulaCobranzaComponent
  ],
  imports: [
    CommonModule
  ], exports:[
    ClausulaCobranzaComponent
  ]
})
export class ClausulaCobranzaModule { }
